import { Tweet } from "@/domain/model/Tweet";
import { User } from "@/domain/model/User";
import { TweetAuthor } from "@/domain/model/TweetAuthor";
export function deserializeTweet(id, { author, body, date, likedBy }) {
    return new Tweet(id, body, deserializeTweetAuthor(author), date.toDate(), likedBy || []);
}
function deserializeTweetAuthor({ id, username, name }) {
    return new TweetAuthor(id, username, name);
}
export function deserializeUser(id, { username, bio, email, following, followers, name }) {
    return new User(id, username, name, email, bio, following, followers);
}
